import * as constants from '@/store/constants'

import Vue from 'vue'
import VueRouter from 'vue-router'

// Login
import Login from '@/components/login/Login'

// Register
import Register from '@/components/forms/Register'
import RegisterSuccess from '@/components/forms/RegisterSuccess'

// Dashboard
import Dashboard from '@/views/Dashboard'
import UserDashboard from '@/views/UserDashboard'
import MainLayout from '@/components/layout/MainLayout'

// Forms
import AdminLetters from '@/components/forms/AdminLetters'
import Air from '@/components/forms/Air'
import LandMovement from '@/components/forms/LandMovement'
import NoStrikeList from '@/components/forms/NoStrikeList'
import TempVenue from '@/components/forms/TempVenue'
import SeaMovement from '@/components/forms/SeaMovement'
import UserProfile from '@/components/forms/UserProfile'

// MOFA
import LandMofa from '@/components/forms/Land-Mofa'
import LandMofaCentcom from '@/components/forms/Land-Mofa-Centcom'
import TempMofa from '@/components/forms/Temp-Mofa'
import AirMofa from '@/components/forms/Air-Mofa'
import SeaMofa from '@/components/forms/Sea-Mofa'
import NSLMofa from '@/components/forms/NSL-Mofa'

// Map
import MapPanel from '@/components/map/MapPanel'
import MapSearch from '@/components/map/MapSearch'

// Reports
import TrackingSheetReport from '@/components/reports/TrackingSheetReport'
import NoStrikeListReport from '@/components/reports/NoStrikeListReport'

// Utility
import nsl2kml from '@/components/utility/NSL2KML'
import pax2csv from '@/components/utility/Pax2Csv'

// User Administration
import UserList from '@/components/list/UserList'

import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      redirect: '/dashboard',
      name: 'Home',
      component: MainLayout,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          beforeEnter: (to, from, next) => {
              if (store.state.permission === constants.ADMIN) {
                  next()
              } 
              else {
                next({ path: '/user-dashboard' })
              }
          }
        },
        {
          path: '/map',
          name: 'map',
          component: MapPanel
        },
        {
          path: '/map-search',
          name: 'map-search',
          component: MapSearch
        },
        {
          path: '/forms',
          redirect: '/forms/admin-letters',
          name: 'Forms',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/forms/admin-letters',
              name: 'Admin Letters',
              component: AdminLetters
            },
            {
              path: '/forms/air-movement',
              name: 'Air Movement',
              component: Air
            },
            {
              path: '/forms/no-strike-list',
              name: 'Static Sites',
              component: NoStrikeList
            },
            {
              path: '/forms/land-movement',
              name: 'Land Movement',
              component: LandMovement
            },
            {
              path: '/forms/sea-movement',
              name: 'Sea Movement',
              component: SeaMovement
            },
            {
              path: '/forms/temp-venue',
              name: 'Temporary Venue',
              component: TempVenue

            },
            {
              path: '/forms/land-mofa',
              name: 'Land Movement MoFA (EHOC)',
              component: LandMofa
            },
            {
              path: '/forms/land-mofa-centcom',
              name: 'Land Movement (CENTCOM)',
              component: LandMofaCentcom
            },
            {
              path: '/forms/temp-mofa',
              name: 'Temporary Venue MoFA',
              component: TempMofa
            },
            {
              path: '/forms/air-mofa',
              name: 'Air MoFA',
              component: AirMofa
            },
            {
              path: '/forms/sea-mofa',
              name: 'Sea MoFA',
              component: SeaMofa
            },
            {
              path: '/forms/nsl-mofa',
              name: 'NSL MoFA',
              component: NSLMofa
            }
          ]
        },
        {
          path: '/maintenance',
          redirect: '/maintenance/user-list',
          name: 'Maintenance',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/maintenance/user-list',
              name: 'Users',
              component: UserList
            }
          ]
        },
        {
          path: '/report',
          redirect: '/report/tracking-sheet',
          name: 'Reports',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/report/tracking-sheet',
              name: 'Tracking Sheet',
              component: TrackingSheetReport
            },
            {
              path: '/report/no-strike-list',
              name: 'No Strike List Report',
              component: NoStrikeListReport
            }
          ]
        },
        {
          path: '/utility',
          redirect: '/utility/nsl2kml',
          name: 'Utility',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {  
              path: '/utility/nsl2kml',
              name: 'Convert NSL to KML',
              component: nsl2kml
            }//,
            // {  
            //   path: '/utility/pax2csv',
            //   name: 'Extract PAX to CSV',
            //   component: pax2csv
            // }        
          ]
        }
      ]
    },
    {
      path: '/home-user',
      redirect: '/user-dashboard',
      component: MainLayout,
      children: [
        {
          path: '/user-dashboard',
          name: 'User Dashboard',
          component: UserDashboard
        },
        {
          path: '/user-profile',
          name: 'User Profile',
          component: UserProfile
        }
      ]
    },    
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/register-success',
      name: 'RegisterSuccess',
      component: RegisterSuccess
    } 
  ]
}) 

router.beforeEach((to, from, next) => {

  if (to.name === 'Login' || to.name === 'Register' || to.name === 'RegisterSuccess') {
      next()
  }
  else if (store.state.token) {
      next()
  }
  else {
    next('/login')  
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js